import { Route, Routes } from "react-router-dom";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import Account from "containers/Account";
import AuthenticatedRoute from "components/AuthenticatedRoute";
import Blockchain from "containers/Signup/Blockchain";
import ChangeEmail from "containers/Account/ChangeEmail";
import ChangePassword from "containers/Account/ChangePassword";
import Confirm from "containers/Login/Confirm";
import Forgot from "containers/Login/Forgot";
import Login from "containers/Login";
import NotFound from "containers/NotFound";
import Processing from "containers/Processing";
import Redeem from "containers/Redeem";
import RedeemTrade from "containers/RedeemTrade";
import SignUp from "containers/Signup";
import UnauthenticatedRoute from "components/UnauthenticatedRoute";
import Verification from "containers/Signup/Verification";
import VerifyEmail from "containers/Account/VerifyEmail";

const promise = loadStripe(process.env.REACT_APP_STRIPE_KEY!);

export default function Routing() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <AuthenticatedRoute>
            <Redeem />
          </AuthenticatedRoute>
        }
      />
      <Route
        path="/activation/trade/:cartId"
        element={
          <AuthenticatedRoute>
            <Elements stripe={promise}>
              <RedeemTrade />
            </Elements>
          </AuthenticatedRoute>
        }
      />
      <Route
        path="/activation/processing/:cartId"
        element={
          <AuthenticatedRoute>
            <Processing />
          </AuthenticatedRoute>
        }
      />
      <Route
        path="/login"
        element={
          <UnauthenticatedRoute>
            <Login />
          </UnauthenticatedRoute>
        }
      />
      <Route
        path="/login/forgot"
        element={
          <UnauthenticatedRoute>
            <Forgot />
          </UnauthenticatedRoute>
        }
      />
      <Route
        path="/login/confirm"
        element={
          <UnauthenticatedRoute>
            <Confirm />
          </UnauthenticatedRoute>
        }
      />
      <Route
        path="/signup"
        element={
          <UnauthenticatedRoute>
            <SignUp />
          </UnauthenticatedRoute>
        }
      />
      <Route
        path="/signup/verification"
        element={
          <UnauthenticatedRoute>
            <Verification />
          </UnauthenticatedRoute>
        }
      />
      <Route
        path="/signup/blockchain"
        element={
          <AuthenticatedRoute>
            <Blockchain />
          </AuthenticatedRoute>
        }
      />
      <Route
        path="/account"
        element={
          <AuthenticatedRoute>
            <Account />
          </AuthenticatedRoute>
        }
      />
      <Route
        path="/account/change-password"
        element={
          <AuthenticatedRoute>
            <ChangePassword />
          </AuthenticatedRoute>
        }
      />
      <Route
        path="/account/change-email"
        element={
          <AuthenticatedRoute>
            <ChangeEmail />
          </AuthenticatedRoute>
        }
      />
      <Route
        path="/account/verify"
        element={
          <AuthenticatedRoute>
            <VerifyEmail />
          </AuthenticatedRoute>
        }
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
